export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10558.4096bcd4.jpg";